export default __webpack_public_path__ + "static/media/mp3.dc2bd047.svg";